import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import IFAList from '../common/IFA/IFAList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Advice',
  emits: ["back"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(IFAList),
    _createElementVNode("button", {
      class: "btn btn-secondary mt-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
    }, "Back")
  ], 64))
}
}

})